import React from "react";
import PropTypes from "prop-types";
import * as DomainConstants from "../../constants/DomainConstants";
import ValidationGroup from "../common/ValidationGroup";
import CheckBoxWithChild from "../common/CheckBoxWithChild";
import { orderByPropertyName } from "../../util/orderBy";

const VerdwijnendeInfrastructurenTable = props => {
    const {
        infrastructuren,
        errors,
        validationMessageType,
        disabled
    } = props;

    const onChange = (id) => {
        return function (event) {
            return props.onChange(event, id);
        };
    };

    function findById(id) {
        const type = props.soortenInfrastructuurAll.find(x => x.id === id);
        if (type) {
            return type.description;
        }
        return "Geen Type";
    }

    const infrastructurenRows = orderByPropertyName(infrastructuren, "naam").map((infrastructuur, i) => {
        const isTypeAndere = infrastructuur.soortInfrastructuurId == DomainConstants.ANDERE_INFRASTRUCTUUR_GUID
            ? (<span><br />{infrastructuur.andereInfrastructuur}</span>)
            : "";

        const reconversie = infrastructuur.deelVanAanvraag.toString() === DomainConstants.DeelVanAanvraag.Reconversie.toString();
        const checkboxDisabled = disabled || infrastructuur.deelVanAanvraag.toString() === DomainConstants.DeelVanAanvraag.Ja.toString();

        return (
            <tr key={i}>
                <td>{infrastructuur.naam}</td>
                <td>{findById(infrastructuur.soortInfrastructuurId)}{isTypeAndere}</td>
                <td style={{ verticalAlign: 'center' }}>
                    <CheckBoxWithChild
                        name={"verdwijnendeInfrastructuur" + i}
                        value={reconversie}
                        onChange={onChange(infrastructuur.id)}
                        size={1}
                        disabled={checkboxDisabled}
                    />
                </td>
            </tr>
        );
    });

    return (
        <ValidationGroup validationMessages={errors ? errors : undefined} validationMessageType={validationMessageType}>
            <table className="c-table hours">
                <thead>
                    <tr>
                        <th width={"50%"}>NAAM VAN DE INFRASTRUCTUUR</th>
                        <th width={"30%"}>TYPE</th>
                        <th width={"20%"}>ZAL VERDWIJNEN</th>
                    </tr>
                </thead>
                <tbody>
                    {infrastructurenRows}
                </tbody>
            </table>
        </ValidationGroup>
    );
};

VerdwijnendeInfrastructurenTable.propTypes = {
    infrastructuren: PropTypes.arrayOf(PropTypes.object),
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    soortenInfrastructuur: PropTypes.array,
	soortenInfrastructuurAll: PropTypes.array,
    disabled: PropTypes.bool
};

export default VerdwijnendeInfrastructurenTable;
